<app-menu-toggle
  tooltip="Performance mode"
  [active]="performanceMode"
  icon="performance"
  (click)="togglePerformance()"
>
</app-menu-toggle>
